import styled from 'styled-components';

import CloseButtonComponent from 'components/close-button';
import Modal from 'components/modal';
import BlockRenderer from 'components/sanity-block-renderer';
import { fadeIn } from 'utils/style/animations';

export const StyledModal = styled(Modal)`
  animation: ${fadeIn} 0.35s forwards;
`;

export const StyledCloseButton = styled(CloseButtonComponent)`
  background-color: ${Styles.color.white};
  svg {
    fill: ${Styles.color.teal};
  }
  && {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
  width: 2rem;
  height: 2rem;
  right: calc(1.25rem + env(safe-area-inset-left));
  position: fixed;
  top: calc(1rem + env(safe-area-inset-top));
  box-shadow: none;
  z-index: ${Styles.zIndex.below};
`;

export const Container = styled.section`
  height: 100%;
  width: 100%;
  padding: 1rem 2rem;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  ${Styles.desktop`
    padding: 0 2rem;
  `}
`;

export const SurpriseInfo = styled.div`
  text-align: center;
`;

export const TitleContainer = styled.div<{ backgroundImage: string }>`
  color: ${Styles.color.white};
  background-image: ${p => `url(${p.backgroundImage})`};
  background-repeat: no-repeat;
  background-position: center;
  margin: 3rem -1rem 0 -1rem;
  height: 4rem;
  line-height: 4rem;
  ${Styles.desktop`
    margin: 0 -1rem 0 -1rem;
  `}
`;

export const Description = styled.p`
  color: ${Styles.color.black};
  font-size: 1.125rem;
  line-height: 1.125rem;
  ${Styles.desktop`
    margin: 1rem auto 0 auto;
    font-size: 1rem;
    line-height: 1rem;
    max-width: 19rem;
  `}
`;

export const SurpriseOptions = styled.div`
  display: flex;
  flex-flow: column wrap;
  overflow-y: scroll;
  margin: 0 -2rem;
  justify-content: flex-start;
  padding: 3rem 0;
`;

export const Prompt = styled.p`
  color: ${Styles.color.white};
  font-size: 1rem;
  margin: 0;
`;

export const SurpriseButtons = styled.div`
  display: flex;
  min-height: 9rem;
  flex-flow: column wrap;
  align-items: center;
  button {
    font-size: 0.875rem;
    color: ${Styles.color.loyaltyHighlight};
    min-width: 12rem;
    ${Styles.desktop`
      font-size: 1rem;
    `}
  }
`;

export const RejectSurprise = styled.a`
  color: ${Styles.color.white};
  cursor: pointer;
  margin-top: 1rem;
  text-decoration: none;
  font-weight: ${Styles.fontWeight.heavy};
  text-transform: capitalize;
`;

export const Terms = styled(BlockRenderer)`
  color: ${Styles.color.black};
  margin-top: 1.5rem;
  & > p > a {
    text-decoration: none;
    color: ${Styles.color.mobileNavButtonColor};
  }
`;
